export { default as PortalIntlBoundary } from './portal-intl-boundary';
